import { service } from "../utils/request";

// 洗车服务
export function addWash(data) {
  return service({
    url: "/service/agent.index/add",
    method: "post",
    data: data
  });
}
export function detailWash(data) {
  return service({
    url: "/service/agent.index/detail",
    method: "post",
    data: data
  });
}
export function editWash(data) {
  return service({
    url: "/service/agent.index/edit",
    method: "post",
    data: data
  });
}
export function indexWash(data) {
  return service({
    url: "/service/agent.index/index",
    method: "post",
    data: data
  });
}
export function delWash(data) {
  return service({
    url: "/service/agent.index/del",
    method: "post",
    data: data
  });
}
export function orderWash(data) {
  return service({
    url: "service/agent.Order/index",
    method: "post",
    data: data
  });
}
export function orderDelWash(data) {
  return service({
    url: "service/agent.Order/del",
    method: "post",
    data: data
  });
}
// ，门店
export function addRoomWash(data) {
  return service({
    url: "service/agent.room/add",
    method: "post",
    data: data
  });
}
export function delRoomWash(data) {
  return service({
    url: "service/agent.room/del",
    method: "post",
    data: data
  });
}
export function editRoomWash(data) {
  return service({
    url: "service/agent.room/edit",
    method: "post",
    data: data
  });
}
export function indexRoomWash(data) {
  return service({
    url: "service/agent.room/index",
    method: "post",
    data: data
  });
}
export function detailRoomWash(data) {
  return service({
    url: "service/agent.room/detail",
    method: "post",
    data: data
  });
}

//员工列表
export function employeeListCar(data) {
  return service({
    url: "service/agent.employee/index",
    method: "post",
    data: data
  });
}

//删除员工
export function employeeDel(data) {
  return service({
    url: "service/agent.employee/del",
    method: "post",
    data: data
  });
}

//添加新账号员工
export function employeeAdd(data) {
  return service({
    url: "service/agent.employee/newEmp",
    method: "post",
    data: data
  });
}

//已有账号绑定员工
export function employeeBind(data) {
  return service({
    url: "service/agent.employee/relateEmp",
    method: "post",
    data: data
  });
}

//获取门店下拉菜单
export function storeSelect(data) {
  return service({
    url: "service/agent.store/roomSelect",
    method: "post",
    data: data
  });
}

//验证手机号是否已注册
export function judgeUser(data) {
  return service({
    url: "service/agent.employee/judgeUser",
    method: "post",
    data: data
  });
}

//员工详情
export function employeeDetail(data) {
  return service({
    url: "service/agent.employee/detail",
    method: "post",
    data: data
  });
}

//员工修改
export function employeeEdit(data) {
  return service({
    url: "service/agent.employee/editEmp",
    method: "post",
    data: data
  });
}

//
